import { FC, useMemo } from 'react'
import { Field, reduxForm } from 'redux-form'
import * as styles from 'styles/molecules/forms/Form.css'
import schema from 'schemas/passwordCodeSendFormSchema'
import { asyncValidator } from 'helpers/schemaHelpers'
import { FORM_PASSWORD_CODE_SEND } from 'constants/forms'
import Button from 'components/features/pfm/Button/Button'
import TextButton from 'components/atoms/buttons/TextButton'
import { ReduxFormProps } from 'interfaces/component'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import { getSaveButtonFormProps, shouldAsyncValidate } from 'helpers/formHelpers'
import { FIELD_EMAIL_PROPS } from 'constants/fields'
import LoginLink from 'components/atoms/LoginLink'

type PasswordCodeSendFormProps = ReduxFormProps

const PasswordCodeSendFormComponent: FC<PasswordCodeSendFormProps> = (props) => {
  const { handleSubmit } = props

  const emailFieldProps = useMemo(() => ({
    ...FIELD_EMAIL_PROPS,
    autoFocus: true,
  }), [])

  return (
    <form className={ styles.formFullWidth } onSubmit={ handleSubmit }>
      <ul>
        <li className={ styles.item }>
          <Field
            name='email'
            props={ emailFieldProps }
            component={ TextFieldWrapped }
          />
        </li>
        <li className={ styles.submitItem }>
          <Button { ...getSaveButtonFormProps(props) } submit fullWidth>
            Request Password Reset
          </Button>
        </li>
        <li className={ styles.cancelLinkWrapper }>
          <LoginLink>
            <TextButton>Cancel</TextButton>
          </LoginLink>
        </li>
      </ul>
    </form>
  )
}

export const PasswordCodeSendForm = reduxForm({
  form: FORM_PASSWORD_CODE_SEND,
  asyncValidate: asyncValidator(schema),
  shouldAsyncValidate,
})(PasswordCodeSendFormComponent)
